import {useCallback, useEffect, useState} from 'react';
import {listTales} from '../api/skazki';

// Lists the account's committed tales from the new tales service
// (`GET /v1/tales?phase=committed`). Tales created via /v1 live in a different
// table than the old celebs flow, so "Мои заказы" must read them here rather
// than from /celebs/account-status. Fetches once on mount; the caller drives
// subsequent refreshes via `refetch` (e.g. on its own interval).
export function useTalesList({enabled = true} = {}) {
    const [tales, setTales] = useState([]);
    const [error, setError] = useState(null);

    const refetch = useCallback(async () => {
        try {
            const {tales: list} = await listTales();
            setTales(list);
            setError(null);
            return list;
        } catch (err) {
            setError(err);
            throw err;
        }
    }, []);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;
        listTales()
            .then(({tales: list}) => {
                if (!cancelled) setTales(list);
            })
            .catch(err => {
                if (!cancelled) setError(err);
            });
        return () => {
            cancelled = true;
        };
    }, [enabled]);

    return {tales, error, refetch};
}
